import React from 'react';
import { FormattedMessage } from 'react-intl';
import eraserSolid from "../../assets/icons/signage-plus/eraser-solid.svg";
import PlaylistPanelItem from './PlaylistPanelItem';
import SwitchComponent from './SwitchComponent';

function PlaylistPanelList({
  playlistOrderMap,
  setPlaylistOrderMap,
  selectedPlaylistId,
  playlistHeader,
  playlistItems,
  dragOverIndex,
  onDragItemStart,
  handleToggleLoop,
  handleItemDragOver,
  handleItemDragLeave,
  handleItemDrop
}) {
   const items = playlistOrderMap[selectedPlaylistId] || playlistItems || [];
  // if (items.length === 0) {
  //   return (
  //     <div className="text-center text-muted" style={{ marginTop: 40 }}></div>
  //   );
  // }
  return (
    <div className="flex-scroll pb-3" style={{ minHeight: 200, overflowY: 'auto' }}>
      <ul className="list-group">
        <li className="d-flex align-items-center justify-content-between h-53"
          style={{ backgroundColor: 'rgba(232, 246, 255, 1)', padding: '0 20px' }}>
          <div className="d-flex align-items-center justify-content-between w-100">
            <div className="form-check form-switch">
              <SwitchComponent check={playlistHeader.isLoop} id={playlistHeader.id} labelId="LOOP_PLAYLIST" className='red' onChange={(checked, id) => {  handleToggleLoop(checked, id) }}  />
            </div>
            <button
              type="button"
              className="d-flex align-items-center justify-content-center playlist-clear-btn"
              onClick={() => {
                setPlaylistOrderMap(map => {
                  const newMap = { ...map };
                  newMap[selectedPlaylistId] = [];
                  return newMap;
                });
              }}
            >
              <img src={eraserSolid} alt="clear" className="playlist-clear-icon" />
              <span className='label-regular'>
                <FormattedMessage id="CLEAR_ALL" defaultMessage="clear all" />
              </span>
            </button>
          </div>
        </li>
        {(playlistOrderMap[selectedPlaylistId] || playlistItems || [])?.map((item, idx) => (
          <PlaylistPanelItem
            key={item.id || idx}
            item={item}
            idx={idx}
            dragOverIndex={dragOverIndex}
            onDragOver={handleItemDragOver}
            onDragLeave={handleItemDragLeave}
            onDrop={handleItemDrop}
            onDragItemStart={onDragItemStart}
            playlistOrderMap={playlistOrderMap}
            setPlaylistOrderMap={setPlaylistOrderMap}
            selectedPlaylistId={selectedPlaylistId}
            playlistItems={playlistItems}
          />
        ))}
      </ul>
    </div>
  );
}

export default PlaylistPanelList;
